import { Component, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { MemberQuery } from '@fgb/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';

@Component({
  selector: 'fgb-account-layout-page',
  templateUrl: './account-layout-page.component.html',
  styleUrl: './account-layout-page.component.scss',
})
export class AccountLayoutPageComponent {
  title: string = '';
  isNormalTitle: boolean = false;
  name$: Observable<string>;
  constructor(private memberQuery: MemberQuery, private router: Router, private destroyRef: DestroyRef) {}
  ngOnInit() {
    const normalTitleRoutes = ['activity'];
    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isNormalTitle = normalTitleRoutes.some((title) => this.router.url.includes(title));
      }
    });
    this.name$ = this.memberQuery.selectMemberDetails().pipe(
      map((m) => {
        if (m) {
          return `${m.FirstName} ${m.Surname}`;
        }
        return '';
      })
    );
  }
}
